/**
 * Каркас выдвижной панели рядом с рейкой команд: заголовок с крестиком закрепён сверху,
 * содержимое ниже занимает остаток высоты. Общий у редактора плана и конструктора мебели.
 */
import type { ReactNode } from "react";
import { Button } from "./Button";
import { Text } from "./Text";

export const DrawerShell = ({
	children,
	label,
	onClose,
}: {
	children: ReactNode;
	label: string;
	onClose: () => void;
}) => (
	<div className="flex h-full min-w-0 flex-col bg-surface">
		<div className="flex h-10 shrink-0 items-center justify-between px-3">
			<Text as="span" className="text-sm font-semibold text-ink">
				{label}
			</Text>
			<Button
				type="button"
				border={false}
				className="flex size-6 items-center justify-center p-0 text-ink/60 hover:text-ink"
				onClick={onClose}
				aria-label="Закрыть"
			>
				✕
			</Button>
		</div>
		<hr className="border-border" />
		<div className="min-h-0 flex-1">{children}</div>
	</div>
);
